import { h, render, Component } from "preact";
import { translate } from "react-i18next";
import { TrustedErrors } from "./error-handling/trustedErrors.js";

// TODO: attribute for successLoginRedirect and successCreateRedirect
// TODO: split off locale, logic based upon attribute lang

let redirectURL;

const locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge:
    'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin:
    "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode:
    "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail:
    "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle:
    "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook:
    "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?",
};

// TODO: load data-* attributes into App state
// TODO: cleanup App state

import Branding from "./LoginPanelBranding.js";
import Inputs from "./LoginPanelInputs.js";
import Loading from "./LoginPanelLoading.js";
import Navigation from "./LoginPanelNavigation.js";
import NoMasterAcct from "./LoginPanelNoMaster.js";

class LoginPanel extends Component {
  tokenToCookie = () => {
    if (this.readCookie("HZAcctWebToken") !== this.getURLParam("webToken")) {
      let encrytpedToken = this.getURLParam("webToken");
      fetch(`https://api.hirezstudios.com/acct/decryptToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: `{"token":"${encrytpedToken}"}`,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.hasOwnProperty("decryptedToken")) {
            this.createCookie("HZAcctWebToken", response.decryptedToken, 30);
            window.location.href = window.location.href.split("?")[0];
          } else {
            this.setState({ resMessage: "Unable to process token. Please try again." });
            window.location.href = window.location.href.split("?")[0];
          }
        });
    }
  };

  createCookie = (name, value, days) => {
    let expires;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
  };

  // read cookie
  readCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  };

  getURLParam = (name, url) => {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regexS = "[\\?&]" + name + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(url);
    return results == null ? null : results[1];
  };

  updateActivePanel = (nextPanel) => {
    this.setState({
      activePanel: nextPanel,
      errorMsg: undefined,
    });
    if (nextPanel === "login" || nextPanel === "create") {
      this.setState({ thirdPartyEmail: undefined });
    }
  };

  updateErrorMessage = (error) => {
    let formattedMessage = error.split("+").join(" ");
    // this.setState({ errorMsg: formattedMessage });
    // console.log(TrustedErrors.includes(formattedMessage));
    if (TrustedErrors.includes(formattedMessage)) {
      this.setState({ errorMsg: formattedMessage });
    }
  };

  thirdPartyAction = (portal, token, email, id) => {
    this.setState({ thirdPartyPortal: portal });
    this.setState({ thirdPartyToken: token });
    this.setState({ thirdPartyEmail: email });
    this.setState({ thirdPartyId: id });
  };

  getLanguageCookie = () => {
    const langCookie = this.readCookie("language_pref");
    this.setState({ langCode: langCookie == undefined ? "en_US" : langCookie });
    this.setLanguagePref(langCookie);
  };

  setLanguagePref = (lang) => {
    switch (lang) {
      case "en_uS":
        this.setState({ language: "English" });
        break;
      case "fr_FR":
        this.setState({ language: "Français" });
        break;
      case "es_LA":
        this.setState({ language: "Español" });
        break;
      case "de_DE":
        this.setState({ language: "Deutsch" });
        break;
      case "pl_PL":
        this.setState({ language: "Polski" });
        break;
      case "ru_RU":
        this.setState({ language: "Русский" });
        break;
      case "tr_TR":
        this.setState({ language: "Turkish" });
        break;
      case "pt_BR":
        this.setState({ language: "Português do Brasil" });
        break;
      case "zh_CN":
        this.setState({ language: "中国" });
        break;
      default:
        this.setState({ language: "English" });
    }
  };

  changeLanguage = (lang) => {
    this.createCookie("language_pref", lang, 365);
    // i18n.changeLanguage(lang);
    window.location = window.location.href.split("?")[0] + "?lng=" + lang;
  };

  qrReaderRedirect = () => {
    if (window.location.href.indexOf("platform") > -1) {
      let platformloc = window.location.href.split("?platform=");
      let platformName = platformloc[1];
      let redirectURL = window.location.origin + window.location.pathname;
      switch (platformName) {
        case "switch":
          window.location.href = "https://api.hirezstudios.com/oauth/out/nintendo?url=" + redirectURL;
          break;
        // Remove this comment when they fix the game client
        // case 'xbox':
        // 	window.location.href = ('https://api.hirezstudios.com/oauth/out/xbox?url=' + redirectURL);
        // 	break;
        case "xbox1":
          window.location.href = "https://api.hirezstudios.com/oauth/out/xbox?url=" + redirectURL;
          break;
        case "xbox":
          window.location.href = "http://www.hirezstudios.com/console-link-redirect/?1";
          break;
        case "playstation":
          window.location.href = "https://api.hirezstudios.com/oauth/out/playstation?url=" + redirectURL;
          break;
        default:
          "";
      }
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      startPanel: null,
      activePanel: "login",
      brandTheme: null,
      brandImage: null,
      brandCopy: null,
      panelCopy: null,
      resMessage: null,
      referral: null,
      thirdPartyPortal: null,
      thirdPartyToken: null,
      thirdPartyEmail: null,
      thirdPartyId: null,
      language: null,
      langCode: null,
      langNavToggled: false,
    };
  }

  componentDidMount() {
    document.body.classList.add("blue");
    if (this.getURLParam("webToken")) {
      this.updateActivePanel("loading");
      this.tokenToCookie();
    }
    if (this.getURLParam("accessToken")) {
      this.updateActivePanel("no-master");
    }
    if (window.location.hash === "#forgot-password") {
      this.updateActivePanel("forgot-password");
    }
    if (window.location.hash === "#forgot-username") {
      this.updateActivePanel("forgot-username");
    }
    if (this.getURLParam("error")) {
      this.updateErrorMessage(this.getURLParam("error"));
    }
    this.qrReaderRedirect();

    //lang switcher
    const lngFromURL = this.getURLParam("lng");
    let lang;

    if (lngFromURL != null) {
      this.createCookie("language_pref", lngFromURL);
      lang = lngFromURL;
    } else {
      this.readCookie("language_pref") == undefined ? this.createCookie("language_pref", "en_US", 365) : "";
      lang = this.readCookie("language_pref") != null ? this.readCookie("language_pref") : "en_US";
    }
  }

  componentWillMount() {
    this.getLanguageCookie();
  }

  mobileLanguageTap = () => {
    if (this.props.windowWidth < 1200) {
      this.state.langNavToggled ? this.setState({ langNavToggled: false }) : this.setState({ langNavToggled: true });
    }
  };

  render() {
    return (
      <form id="hirez-acct-form">
        <div
          className={"language-wrapper " + (this.state.langNavToggled ? "mobile-expanded" : "")}
          onClick={this.mobileLanguageTap}
        >
          <div className="lang-select">
            {this.state.language && this.state.language}
            <i className="ion-android-arrow-dropdown"></i>
            <div className="languages">
              <a onClick={() => this.changeLanguage("en_US")}>English</a>
              <a onClick={() => this.changeLanguage("fr_FR")}>Français</a>
              <a onClick={() => this.changeLanguage("de_DE")}>Deutsch</a>
              <a onClick={() => this.changeLanguage("es_LA")}>Español</a>
              <a onClick={() => this.changeLanguage("pl_PL")}>Polski</a>
              <a onClick={() => this.changeLanguage("ru_RU")}>Русский</a>
              <a onClick={() => this.changeLanguage("pt_BR")}>Português do Brasil</a>
              <a onClick={() => this.changeLanguage("tr_TR")}>Turkish</a>
              <a onClick={() => this.changeLanguage("zh_CN")}>中国</a>
            </div>
          </div>
        </div>
        <Branding />
        <div className="error-message">{this.state.errorMsg}</div>
        {this.state.activePanel === "loading" && (
          <Loading panel={this.state.activePanel} callback={this.updateActivePanel} />
        )}
        {this.state.activePanel === "no-master" && (
          <NoMasterAcct panel={this.state.activePanel} callback={this.updateActivePanel} />
        )}
        {this.state.activePanel !== "no-master" && this.state.activePanel !== "loading" && (
          <Inputs
            panel={this.state.activePanel}
            callback={this.updateActivePanel}
            thirdPartyPortal={this.state.thirdPartyPortal}
            thirdPartyToken={this.state.thirdPartyToken}
            thirdPartyEmail={this.state.thirdPartyEmail}
            thirdPartyId={this.state.thirdPartyId}
          />
        )}
        <Navigation
          panel={this.state.activePanel}
          callback={this.updateActivePanel}
          lastPanel={this.state.lastPanel}
          thirdParty={this.thirdPartyAction}
        />
      </form>
    );
  }
}

export default translate(["common"], { withRef: true })(LoginPanel);



// WEBPACK FOOTER //
// ./components/LoginPanel.js